import { render, staticRenderFns } from "./SecondaryHeader.vue?vue&type=template&id=c6133cf8"
import script from "./SecondaryHeader.vue?vue&type=script&lang=js"
export * from "./SecondaryHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports